import assign = require('object-assign');
import {
    FETCH_CUSTOMER_REQUEST, FETCH_CUSTOMER_SUCCESS, FETCH_CUSTOMER_FAILURE,
} from '../../constants/Customer';

import { IWidgetDataState } from '../../interfaces/states';

const initialState = {};

export function isResponsible(action) {
    switch (action.type) {
        case FETCH_CUSTOMER_REQUEST:
        case FETCH_CUSTOMER_SUCCESS:
        case FETCH_CUSTOMER_FAILURE:
            return true;
        default:
            return false;
    }
}

export default function customer(state = initialState, action): IWidgetDataState {
    switch (action.type) {
        case FETCH_CUSTOMER_REQUEST: {
            return assign({}, state, {
                customer: {
                    loading: true
                }
            });
        }
        case FETCH_CUSTOMER_SUCCESS: {
            return assign({}, state, {
                customer: {
                    loading: false,
                    data: action.payload
                }
            });
        }
        case FETCH_CUSTOMER_FAILURE: {
            return assign({}, state, {
                customer: {
                    loading: false,
                    error: action.error,
                    data: action.payload
                }
            });
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/widgetData/customer.ts